import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectionService } from '../../../../services/connection-service';
import { LocalStorage } from '../../../../services/local-storage-service';
import { Broadcaster } from '../../../../components/broadcaster';
import { AppConfig } from '../../../app.config';
import { ApiClientConstant } from '@cureskin/api-client';
import { RegimenService } from '../../../../services/regimen-service';

@Component({
    selector: 'regimen-list', templateUrl: './regimen-list.html', styleUrls: ['./regimen-list.scss'],
    standalone: false
})
export class RegimenListComponent {
  @Input('ui') ui: any = {};
  @Input('supportTicketId') supportTicketId: string;
  @Input('user')
  set userFunction(user: any) {
    this.user = user;
    if (!this.user || !this.user.id) {
      this.regimens = [];
      return;
    }
    this.getUserRegimens();
  }
  user: any;
  baseUrlForWebApp: string;
  userRoles: Array<string> = [];
  regimens: Array<any> = [];
  recentOrders: Array<any> = [];
  recentBoughtProducts: Array<any> = [];
  regimenProducts: Array<any> = [];
  unorderedRegimenProducts: Array<any> = [];
  cutoffDaysForRecentOrders: number = 1000*60*60*24*80; // 80 days

  public subscriptions: Subscription[] = [];

  constructor(private conn: ConnectionService,
    private storage: LocalStorage,
    private appConfig: AppConfig,
    private readonly broadcaster: Broadcaster,
    private readonly regimenService: RegimenService) {
  }

  async ngOnInit(): Promise<any> {
    this.userRoles = this.storage.getJsonValue('userRoles');
    this.baseUrlForWebApp = this.conn.getWebAppUrl();
  }

  async getUserRegimens(): Promise<any> {
    this.regimens = await this.regimenService.fetchRegimensForUser(this.user);
    this.regimenProducts = this.regimens.flatMap((each: any) => each.get('products').map((product: any) => product.toJSON()));
    await this.getUserRecentOrders();
  }

  async deleteRegimen(regimen: any): Promise<void> {
    try {
      regimen.destroy();
      this.broadcaster.broadcast('NOTIFY', { message: 'Regimen deleted successfully.' });
    } catch (error) {
      this.broadcaster.broadcast('NOTIFY', { message: error.toString(),
        type: this.appConfig.Shared.Toast.Type.ERROR });
    }
  }

  async resendRegimen(index: number): Promise<any> {
    try {
      this.ui.savingMessage = true;
      const regimenId: string = this.regimens[index].get('regimenId');
      let context = {};
      if (this.supportTicketId) {
        context = { supportTicketId: this.supportTicketId };
      }
      const personalizedRegimen = await this.conn.sendOrCreatePersonalizedRegimen(regimenId, this.user.get('username'), context);
      if (this.regimens.every((regimen: any) => (regimen.get('regimenId') !== personalizedRegimen.get('regimenId')))) {
        this.regimens.push(personalizedRegimen);
      }
      this.ui.savingMessage = false;
    } catch (err) {
      this.ui.savingMessage = false;
    }
  }

  async getUserRecentOrders(): Promise<any> {
    const orders = await this.conn.findOrders({
      where: { user: this.user, createdAt: { $gte: new Date(Date.now() - this.cutoffDaysForRecentOrders) }, stage: { $in: ApiClientConstant.Order.OrderStagePostOrderPlaced } },
      descending: 'createdAt',
      include: ['products', 'products.margId' as 'products'],
    });
    this.recentOrders = orders.map((each: any) => each.toJSON());
    this.recentBoughtProducts = this.recentOrders.flatMap((each: any) => each.products);
    this.regimenProductsNotInRecentBoughtProducts();
  }

  regimenProductsNotInRecentBoughtProducts(): void {
    const recentBoughtMargIds = this.recentBoughtProducts.map((product: any) => product.margId);
    this.unorderedRegimenProducts = this.regimenProducts.filter((regimenProduct: any) => {
      const regimenMargId = regimenProduct.margId;
      return !recentBoughtMargIds.includes(regimenMargId);
    });
  }
}
